<nav class="navbar navbar-expand-lg navbar-light bg-light" style="background-color: #e3f2fd;">
  <img src="../../../assets/logo.png" style="width: 80px; height: 50px;"> <a class="navbar-brand"[routerLink]="['/home']">Human-e-finance</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav" style="justify-content: flex-end;">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link"[routerLink]="['/home']">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link"[routerLink]="['/about']">About</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"[routerLink]="['/product']">Get Started</a>
      </li>
      <!-- <button mat-icon-button [routerLink]="['/account']">
        <mat-icon>person</mat-icon>
      </button> -->
    </ul>
  </div>
</nav>